<div class="date-picker-form" *ngIf="allowedRange && _minDate">
  <div class="row" *ngIf="switchCase(transportForm.controls.pickupMeeting.value !== true, transportForm.controls.deliveryMeeting.value !== true)">
    <div class="col-12">
      <jhi-bary-title
        [titleKey]="switchCase('forms.datePickerForm.date.titlePickup', 'forms.datePickerForm.date.titleDelivery')"
        [tooltip]="'forms.datePickerForm.date.warningDate' | translate: { companyName: transporter.companyName }"
        [class]="'bold text-dark'"
      ></jhi-bary-title>
      <jhi-bary-date-picker
        [title]="switchCase('forms.datePickerForm.date.titlePickup' | translate, 'forms.datePickerForm.date.titleDelivery' | translate)"
        [label]="switchCase('forms.datePickerForm.date.labelPickup' | translate, 'forms.datePickerForm.date.labelDelivery' | translate)"
        [control]="switchCase(transportForm.controls.pickupDate, transportForm.controls.deliveryDate)"
        [id]="id + switchCase('.pickupDate', '.deliveryDate')"
        [isPickup]="switchCase(true, false)"
        [disabled]="disabled"
        [options]="datePickerOptions"
        [limitDay]="8"
        [forceRefreshOptions]="forceRefreshOptions"
        [isUpdate]="isUpdate"
      ></jhi-bary-date-picker>
    </div>
    <div class="col-12 pt-2">
      <jhi-bary-multi-slider
        [id]="id + switchCase('.pickupTimeslot', '.deliveryTimeslot')"
        [controlStart]="switchCase(transportForm.controls.pickupTimeslotStart, transportForm.controls.deliveryTimeslotStart)"
        [controlEnd]="switchCase(transportForm.controls.pickupTimeslotEnd, transportForm.controls.deliveryTimeslotEnd)"
        [allowedRange]="allowedRange"
      ></jhi-bary-multi-slider>
    </div>
  </div>
  <div class="row pt-4">
    <div class="col-12" *ngIf="this.transportConfiguration.meetingAllowed">
      <jhi-bary-input-checkbox
        *ngIf="!switchCase(transportForm.controls.pickupPhoneCall, transportForm.controls.deliveryPhoneCall).value"
        [id]="id + switchCase('.pickupMeeting', '.deliveryMeeting')"
        [label]="'forms.datePickerForm.meeting.label' | translate"
        [control]="switchCase(transportForm.controls.pickupMeeting, transportForm.controls.deliveryMeeting)"
        [tooltip]="'forms.datePickerForm.meeting.tooltip' | translate"
      ></jhi-bary-input-checkbox>
      <jhi-bary-input-checkbox
        *ngIf="switchCase(transportForm.controls.pickupPhoneCall, transportForm.controls.deliveryPhoneCall).value"
        [disabled]="true"
        [id]="id + switchCase('.pickupMeeting', '.deliveryMeeting')"
        [label]="'forms.datePickerForm.meeting.label' | translate"
        [tooltip]="'forms.datePickerForm.meeting.tooltip' | translate"
      ></jhi-bary-input-checkbox>
    </div>
    <div class="col-12" *ngIf="this.transportConfiguration.phoneCallAllowed">
      <jhi-bary-input-checkbox
        *ngIf="!switchCase(transportForm.controls.pickupMeeting, transportForm.controls.deliveryMeeting).value"
        [id]="id + switchCase('.pickupPhoneCall', '.deliveryPhoneCall')"
        [label]="'forms.datePickerForm.callBefore.label' | translate"
        [tooltip]="'forms.datePickerForm.callBefore.tooltip' | translate"
        [control]="switchCase(transportForm.controls.pickupPhoneCall, transportForm.controls.deliveryPhoneCall)"
      ></jhi-bary-input-checkbox>
      <jhi-bary-input-checkbox
        *ngIf="switchCase(transportForm.controls.pickupMeeting, transportForm.controls.deliveryMeeting).value"
        [disabled]="true"
        [id]="id + switchCase('.pickupPhoneCall', '.deliveryPhoneCall')"
        [label]="'forms.datePickerForm.callBefore.label' | translate"
        [tooltip]="'forms.datePickerForm.callBefore.tooltip' | translate"
      ></jhi-bary-input-checkbox>
    </div>
  </div>
</div>
